// 🔧 passport_seeder.js
// ✅ Purpose: Seeds Passport demo data into Firestore
// ✅ Features:
// - Coordinates persistence of Passport stops, rewards, achievements, and progress
// - Calls repository layer only
// - No Firestore logic here
// - Returns standardized results to Builder
// - Fully block-commented for clarity and future devs

import { savePassportData } from "./passport_repository";

export const seedPassport = async ({
  demoContext,
  passportPlan,
} = {}) => {
  console.log("🌱 Passport Seeder started.");

  if (!passportPlan) {
    throw new Error("Passport Seeder requires passportPlan.");
  }

  const results = await savePassportData({
    demoContext,
    stops: passportPlan.stops || [],
    rewards: passportPlan.rewards || [],
    achievements: passportPlan.achievements || [],
    progress: passportPlan.progress || [],
  });

  console.log("✅ Passport Seeder completed.", {
    stops: results.stops.length,
    rewards: results.rewards.length,
    achievements: results.achievements.length,
    progress: results.progress.length,
  });

  return results;
};